<template>
  <v-snackbar
    v-model="toastData.isOpen"
    :timeout="toastData.timeout?toastData.timeout:2000"
  >
    {{ toastData.text }}
    <template v-slot:action="{ attrs }">
      <v-btn
        color="blue"
        text
        v-bind="attrs"
        @click="closeToast"
      >
        <i class="icon-cross-circle"/>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Toast',
  data () {
    return {
      isShow: false
    }
  },
  computed: {
    ...mapGetters(['toastData'])
  },
  methods: {
    ...mapActions(['showToast']),
    closeToast () {
      this.setToastData({
        isOpen: false,
        text: ''
      })
    }
  }
}
</script>

<style scoped>

</style>
